import { Component, Host, Prop, h } from '@stencil/core';
import { isEmpty } from '../../utils/helpers/helpers';

@Component({
  tag: 'lgr-card',
  styleUrl: 'card.scss',
  shadow: true,
})
export class Card {
  /**
   * The path for the card's image file.
   */
  @Prop({ reflect: true }) imageSrc?: string;
  /**
   * Textual description for the card's image.
   */
  @Prop({ reflect: true }) imageAlt?: string;

  /**
   * Icon name to be used on the card.
   */
  @Prop({ reflect: true }) icon?: string;

  /**
   * Main title for the card.
   */
  @Prop({ reflect: true }) heading?: string;
  /**
   * 
   */
  @Prop({ reflect: true }) headingSize: 'xx-large' | 'x-large' | 'large' | 'medium' | 'small' | 'x-small' = 'medium'
  /**
   * 
   */
  @Prop({ reflect: true }) textSize?: 'large' | 'small' | 'x-small' = 'x-small';
  /**
   * Text to be placed in the main button.
   */
  @Prop() mainButtonLabel?: string;
  /**
   * Text to be placed in the secondary button.
   */
  @Prop() secondaryButtonLabel?: string;
  /**
   * Action to be performed when the main button is clicked.
   */
  @Prop() mainAction?: () => void;
  /**
   * Action to be performed when the secondary button is clicked.
   */
  @Prop() secondaryAction?: () => void;

  render() {
    return (
      <Host tabindex="0">
        <div class="lgr-card">
          <div class="lgr-card-image-container">
            {!isEmpty(this.imageSrc) && (
              <img src={this.imageSrc} alt={this.imageAlt}></img>
            )}
            <slot />
          </div>
          <div class="lgr-card-content-container">
            <div class="lgr-card-text-container">
              <slot name="tag" />
              {!isEmpty(this.icon) && isEmpty(this.imageSrc) && <lgr-icon aria-hidden="true">{this.icon}</lgr-icon>}
              {!isEmpty(this.heading) && <lgr-heading dark size={this.headingSize} role="heading">{this.heading}</lgr-heading>}
              <lgr-text role="text" size={this.textSize}>
                <slot name="text" />
              </lgr-text>
            </div>
            <div class="lgr-card-number-container">
              <slot name="number" />
            </div>
            <div class="lgr-card-buttons-container">
              {!isEmpty(this.mainButtonLabel) && (
                <lgr-button size="small" onClick={this.mainAction}>
                  {this.mainButtonLabel}
                </lgr-button>
              )}
              {!isEmpty(this.secondaryButtonLabel) && (
                <lgr-button size="small" variant="text" onClick={this.secondaryAction}>
                  {this.secondaryButtonLabel}
                </lgr-button>
              )}
              <slot name="main-button" />
              <slot name="secondary-button" />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
